
import Textline from './_Textline.js';

export default class Features{
	constructor(){
		this.initFeatures();
	}
	initFeatures(){
		const pcFeatureSection = (section)=>{
			const visual = section.querySelector(".features__section__visual__container");
			const body = section.querySelector(".features__section__body");
			const contents = section.querySelector(".features__section__body__contents");
			const axis1 = section.querySelector(".features__section__visual__axis1");
			const axis2 = section.querySelector(".features__section__visual__axis2");
			const images = section.querySelector(".features__section__visual__images");
			const imageSlide = Array.from(section.querySelectorAll(".features__section__visual__images__slide")).map(image=>{
				return [image, image.querySelector("img")];
			});
			const imageBorder = 0;
			const featureLineset = section.querySelectorAll(".textline");
			const featureTextline = new Textline(featureLineset);
			const scrollUpdate = (progress)=>{
				featureTextline.textProgress(progress);
				const scrollPosition = ( (images.offsetHeight+rpx(imageBorder)) * (imageSlide.length-1) ) * progress;
				imageSlide.forEach((slide,i)=>{
					const initialPosition = i*(images.offsetHeight+rpx(imageBorder));
					const unitProgress = Math.max(-1, Math.min(1, progress*(imageSlide.length-1) - i));
					slide[0].style.transform = "translateY("+(initialPosition-scrollPosition)+"px)";
					slide[1].style.transform = "translateY("+(20*unitProgress)+"%)";
				});
			}

			const weddingHeader = document.querySelector(".wedding__navigation");
			const featureAxis1 = gsap.fromTo(axis1, {
				yPercent: -20,
			},{ 
				yPercent: 0,
				ease: "none",
				scrollTrigger: { 
					trigger: section,
					start: ()=>"top-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" bottom",
					end: ()=>"top-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" top",
					scrub: true,
				}
			});
			const featureAxis2 = gsap.fromTo(axis2, {
				yPercent: 0,
			},{ 
				yPercent: 20,
				ease: "none",
				scrollTrigger: { 
					trigger: section,
					start: "bottom bottom",
					end: "bottom top",
					scrub: true,
				}
			});

			const titleset = section.querySelector(".features__section__titleset");
			ScrollTrigger.create({
				trigger: titleset,
				start: ()=>"top-="+(section.classList.contains("rightsection") ? rpx(60+35) : rpx(35))+" top",
				endTrigger: section,
				end: ()=>"bottom bottom",
				pin: true,
				pinSpacing: false
			});

			imageSlide.forEach((slide,i)=>{
				slide[0].style.transform = "translateY("+(i*(images.offsetHeight+rpx(imageBorder)))+"px)";
			});
			const contentsPin = ScrollTrigger.create({
				trigger: contents,
				start: ()=>"top-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" top",
				endTrigger: section,
				end: ()=>"bottom bottom",
				pin: true,
				pinSpacing: false,
				onUpdate: self=>scrollUpdate(self.progress)
			});
			const visualPin = ScrollTrigger.create({
				trigger: visual,
				start: ()=>()=>"top-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" top",
				endTrigger: section,
				end: ()=>"bottom bottom",
				pin: true,
				pinSpacing: false
			});
		}
		const spFeatureSection = (section)=>{
			const body = section.querySelector(".features__section__body");
			const contents = section.querySelector(".features__section__body__contents");
			const slide1 = section.querySelector(".features__section__visual__images__slide.slide1");
			const slide2 = section.querySelector(".features__section__visual__images__slide.slide2");
			const slide1img = slide1.querySelector("img");
			const slide2img = slide2.querySelector("img");
			const weddingHeader = document.querySelector(".wedding__navigation");
			const stickyReserveNav = document.querySelector(".stickyReserveNav");
			const featureLineset = section.querySelectorAll(".textline");
			const featureTextline = new Textline(featureLineset);
			const scrollUpdate = (progress)=>{
				featureTextline.textProgress(progress);
			}

			if(slide1 && slide1img){
				gsap.fromTo(slide1img, {
					yPercent: 0,
				},{ 
					yPercent: 20,
					ease: "none",
					scrollTrigger: { 
						trigger: slide1,
						start: ()=>"top-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" bottom",
						end: ()=>"bottom-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" top",
						scrub: true,
					}
				});
			}
			if(slide2 && slide2img){
				gsap.fromTo(slide2img, {
					yPercent: 0,
				},{ 
					yPercent: 33.33,
					ease: "none",
					scrollTrigger: { 
						trigger: slide2,
						start: ()=>"top-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" bottom",
						end: ()=>"bottom-="+(weddingHeader ? weddingHeader.offsetHeight : 0)+" top",
						scrub: true,
					}
				});
			}

			const titleset = section.querySelector(".features__section__titleset");
			let titlesetoffset = 0;
			if(titleset && section.classList.contains("rightsection")){
				titlesetoffset = rpx(20);
			}
			
			/*
			ScrollTrigger.create({
				trigger: titleset,
				start: ()=>"top-="+(section.classList.contains("rightsection") ? rpx(40+15) : rpx(15))+" top",
				endTrigger: body,
				end: ()=>"bottom+="+((window.lvh - contents.offsetHeight - (weddingHeader ? rpx(110) : 0))/2 - titlesetoffset + (weddingHeader ? rpx(26) : 0) + (stickyReserveNav ? rpx(-15) : 0))+" bottom",
				pin: true,
				pinSpacing: false
			});
			const contentsPin = ScrollTrigger.create({
				trigger: contents,
				start: ()=>"center-="+((weddingHeader ? rpx(30) : 0) + (stickyReserveNav ? rpx(-15) : 0) + titlesetoffset)+" center",
				endTrigger: body,
				end: ()=>"bottom+="+((window.lvh - contents.offsetHeight - (weddingHeader ? rpx(110) : 0))/2 - titlesetoffset + (weddingHeader ? rpx(26) : 0) + (stickyReserveNav ? rpx(-15) : 0))+" bottom",
				pin: true,
				pinSpacing: false,
				onUpdate: self=>scrollUpdate(self.progress)
			});
			*/
		}

		const features = document.querySelectorAll(".features");
		features.forEach(feature=>{
			const section = feature.querySelectorAll(".features__section");
			if(window.currentContext == "pc"){
				const featureTitleset = feature.querySelector(".features__titleset");
				const featuresSection1 = feature.querySelector(".features__section");
				if(featureTitleset && featuresSection1){
					const weddingHeader = document.querySelector(".wedding__navigation");
					const isTitleRight = featureTitleset.classList.contains("righttitle");
					ScrollTrigger.create({
						trigger: featureTitleset,
						start: ()=>"top top+="+((weddingHeader || isTitleRight) ? rpx(100) : rpx(30)),
						endTrigger: featuresSection1,
						end: ()=>"bottom bottom",
						pin: true,
						pinSpacing: false
					});
				}
				section.forEach(section=>{
					pcFeatureSection(section);
				});
			}else{
				section.forEach(section=>{
					spFeatureSection(section);
				});
			}
		});
	}
}